// src/pages/materials/Create.jsx
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const Card = ({ title, desc, onClick }) => (
  <button
    onClick={onClick}
    className="block w-full text-left border rounded-lg p-3 hover:bg-gray-50 active:bg-gray-100 transition-colors"
  >
    <div className="text-sm font-semibold text-gray-900">{title}</div>
    <div className="text-xs text-gray-500 mt-1">{desc}</div>
  </button>
);

export default function MaterialsCreate() {
  const nav = useNavigate();
  const { id: projectId } = useParams();

  // 공식 템플릿용 라우트 계산기
  const goOfficial = (formType) => {
    const t = String(formType).toUpperCase();

    let base = "plan"; // PS 기본
    if (t === "PO") base = "order";
    else if (t === "GR" || t === "GI") base = "inout";
    else if (t === "QC" || t === "CK") base = "check";

    // ✅ :mode 제거, 공식 폼은 /new?form_type=... 로 진입
    nav(`/project/${projectId}/materials/${base}/new?form_type=${t}`);
  };

  return (
    <div
      className="mobile-page-root mb-16"
      style={{ width: '100%', maxWidth: '100vw', minWidth: 0, display: 'flex', justifyContent: 'center', overflowX: 'hidden', boxSizing: 'border-box' }}
    >
      <div
        className="mobile-page-root-inner space-y-3"
        style={{ width: '100%', maxWidth: '480px', margin: '0 auto', padding: '0 1rem 1rem', boxSizing: 'border-box', overflowX: 'hidden' }}
      >
        {/* 헤더 */}
        <div className="bg-white rounded-lg p-4 border min-w-0">
          <h2 className="text-lg font-bold text-gray-900">문서 만들기</h2>
        </div>

        {/* 사용자 템플릿(공용 1개) */}
        <div className="rounded-lg border bg-white min-w-0">
          <div className="border-b px-4 py-3 font-medium text-sm">템플릿</div>
          <div className="p-4">
            <Card
              title="사용자 템플릿 (공용 1개)"
              desc="프로젝트 공용 사용자 템플릿으로 새 문서를 시작합니다."
              onClick={() =>
                nav(`/project/${projectId}/materials/template/new`)
              }
            />
          </div>
        </div>

        {/* 공식 규격 템플릿 - 문서 종류별 단건 생성 */}
        <div className="rounded-lg border bg-white min-w-0">
          <div className="border-b px-4 py-3 font-medium text-sm">공식 규격 템플릿</div>
          <div className="grid gap-3 p-4 grid-cols-2">
            <Card
              title="수급계획"
              desc="자재 수급 계획 공식 양식"
              onClick={() => goOfficial("PS")}
            />
            <Card
              title="발주서"
              desc="자재 발주 공식 양식"
              onClick={() => goOfficial("PO")}
            />
            <Card
              title="입고서"
              desc="자재 입고 공식 양식"
              onClick={() => goOfficial("GR")}
            />
            <Card
              title="출고서"
              desc="자재 출고 공식 양식"
              onClick={() => goOfficial("GI")}
            />
            <Card
              title="검수 요청"
              desc="검수 요청 공식 양식"
              onClick={() => goOfficial("QC")}
            />
            <Card
              title="검수 확인"
              desc="검수 확인 공식 양식"
              onClick={() => goOfficial("CK")}
            />
          </div>
        </div>

        <div className="text-xs text-gray-500 bg-white rounded-lg p-3 border">
          * 생성 후 상세 화면에서 상태(임시저장/승인/종결) 등을 설정합니다.
        </div>
      </div>
    </div>
  );
}
